





















































import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'

import AuthModal from '@/components/AuthModal.vue'
import FacebookButton from '@/components/FacebookButton.vue'
import FbLoginMixin from '@/components/FbLoginMixin.vue'
import LoginForm from '@/components/LoginForm.vue'

import ErrorEntities from '@/models/error-entities'
import LoginCredentials from '@/models/login-credentials'

import { AuthActionTypes } from '@/store/modules/auth/actions'

@Component({
  components: {
    AuthModal,
    FacebookButton,
    LoginForm,
  },
})
export default class Login extends mixins(FbLoginMixin) {
  get error() {
    if (this.facebookLoginErrors.notConnected) {
      return null
    }

    return this.$store.getters.getLoginPageError
  }

  get facebookLoginErrors(): ErrorEntities {
    return this.$store.state.facebook.errors
  }

  get formPending() {
    return this.$store.getters.getLoginPagePending
  }

  onLogin(credentials: LoginCredentials) {
    const redirectTo = '/'
    this.$store.dispatch(AuthActionTypes.Login, { credentials, redirectTo })
  }
}
